export class SupplementaryEquipment {
  equipmentTypeId: string;
  name: string;
  selected: boolean;
  identifier: string;
}


export class SupplementaryEquipmentHandout {
  visitId: number;
  firstname: string;
  name: string;
  company: string;
  supplementaryEquipments: SupplementaryEquipment[] = [];
}
